import { makeAutoObservable, runInAction } from "mobx";

import { Magazine } from "./Magazine";
import { Stock } from "./Stock";
import { StockistQuantityDiscountModelDTO } from "./Discount/StockistQuantityDiscountModelDTO";

export class StockistIssue {
  readonly id: number
  readonly identity: string
  readonly imageAvailable: boolean
  readonly imageURL_140x195: string
  readonly imageURL_230x320: string
  readonly stockistIssueText: string
  readonly keywords: string
  readonly magazine: Magazine
  readonly magazineId: number
  readonly issueOnSale: Date
  readonly issueOffSale: Date
  readonly onSaleDateDisplay: string
  readonly isBackIssue: boolean
  readonly price: number
  readonly priceDisplay: string
  readonly stock: Stock
  readonly weight: number
  readonly weightGrams: number
  readonly thicknessInMM: number
  readonly mostSpecificDiscounts: StockistQuantityDiscountModelDTO[]
  readonly previousIssuesImageURLs: string[]
  readonly magazineCurrentIssueInfo: StockistIssue | null

  updateInBasket(inBasket: number) {
    runInAction(() => this.stock.inBasket = inBasket)
  }

  get weightKilograms(): number {
    return this.weightGrams / 1000
  }

  constructor(
    data: {
      id: number,
      identity: string,
      imageAvailable: boolean,
      imageURL_140x195: string,
      imageURL_230x320: string,
      stockistIssueText: string,
      keywords: string,
      magazine: Magazine,
      magazineId: number,
      issueOnSale: Date,
      issueOffSale: Date,
      onSaleDateDisplay: string,
      isBackIssue: boolean,
      price: number,
      priceDisplay: string,
      stock: Stock,
      weight: number,
      weightGrams?: number,
      thicknessInMM: number,
      mostSpecificDiscounts: StockistQuantityDiscountModelDTO[],
      previousIssuesImageURLs: string[],
      magazineCurrentIssueInfo: StockistIssue | null
    }) {
    this.id = data.id
    this.identity = data.identity
    this.imageAvailable = data.imageAvailable
    this.imageURL_140x195 = data.imageURL_140x195
    this.imageURL_230x320 = data.imageURL_230x320
    this.magazine = new Magazine(data.magazine)
    this.stockistIssueText = data.stockistIssueText
    this.keywords = data.keywords
    this.magazineId = data.magazineId
    this.issueOnSale = new Date(data.issueOnSale)
    this.issueOffSale = new Date(data.issueOffSale)
    this.onSaleDateDisplay = data.onSaleDateDisplay
    this.isBackIssue = data.isBackIssue
    this.price = data.price
    this.priceDisplay = data.priceDisplay
    this.stock = new Stock(data.stock.isInStockStockist, data.stock.stockAvailableForStockist, data.stock.stockStockistDisplay, data.stock.inBasket);
    this.weight = data.weight
    this.weightGrams = data.weightGrams || this.weight
    this.thicknessInMM = data.thicknessInMM
    this.mostSpecificDiscounts = data.mostSpecificDiscounts
    this.previousIssuesImageURLs = data.previousIssuesImageURLs
    this.magazineCurrentIssueInfo = data.magazineCurrentIssueInfo
    makeAutoObservable(this)
  }
}